import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  InspectionWizardResponse,
  InspectionWizardVMBaseClass,
} from '../models/coverage-validator-api-models';

// Errors are left as HttpErrorResponse: the store maps them to what the page shows.
@Injectable({
  providedIn: 'root',
})
export class InspectionService {
  private http = inject(HttpClient);

  // The insured token names the inspection, so no id goes on the URL.
  getInspection(): Promise<InspectionWizardResponse> {
    return firstValueFrom(this.http.get<InspectionWizardResponse>('Inspection'));
  }

  saveWizard(wizard: InspectionWizardVMBaseClass): Promise<void> {
    return firstValueFrom(this.http.put<void>('Inspection/wizard', wizard));
  }

  completeInspection(): Promise<void> {
    return firstValueFrom(this.http.post<void>('Inspection/complete', null));
  }
}
